<div
  class="card standalone fade home-component"
  [ngClass]="{
    'show': isReady()
  }"
>
</div>
